import { C } from "../common/component";
import { Dom } from "../common/dom";
import { Collapse } from "../common/collapse";
import { Txt } from "../common/text";
import { TimesheetShortcutsSet } from "./timesheet-shortcuts-set";
import { TimesheetShortcut } from "./timesheet-models";
import { ButtonBuilder } from "../common/button-builder";
import { Tooltip } from "../common/tooltip";
import { StorageHelper, StorageItem } from "../common/storage-helper";

export class TimesheetShortcutsPanel
{
    private readonly panelParent;

    constructor(parent)
    {
        const buttonParent = C.buttonsGroup.css("margin-top", "21px").css("margin-left", "10px").appendTo(parent);
        this.panelParent = C.div.addClass("schedule").appendTo(parent);

        const toggleButton = ButtonBuilder.get({
            name: Txt.hideShortcuts
        }).appendTo(buttonParent);
        const setShortcutsVisibility = (show: boolean) =>
        {
            toggleButton.text(show ? Txt.hideShortcuts : Txt.showShortcuts);
            if (show)
            {
                Collapse.show(this.panelParent[0]);
            }
            else
            {
                Collapse.hide(this.panelParent[0]);
            }
        };
        let shown = !StorageHelper.get(StorageItem.hideTimesheetShortcuts);
        toggleButton.text(shown ? Txt.hideShortcuts : Txt.showShortcuts);
        Collapse.init(this.panelParent[0], shown);
        toggleButton.click( () =>
        {
            shown = !shown;
            StorageHelper.set(StorageItem.hideTimesheetShortcuts, !shown);
            setShortcutsVisibility(shown);
        });
    }

    set(shortcuts: TimesheetShortcutsSet)
    {
        this.panelParent.empty();
        const container = C.div.addClass("w-form-group").appendTo(this.panelParent);
        C.label.addClass("schedule-label").text(Txt.vactionAndShiftLegend).appendTo(container);

        for (const group of shortcuts.getDisplayGroups())
        {
            const abbreviations = C.div.css("margin-bottom", "5px").appendTo(container);
            for (const item of group.displayedShortcuts)
            {
                const titleSpan = this.addShortcut(item, abbreviations);
                if (item.Start || item.End)
                {
                    let tooltipText = "";
                    const addLine = (label: string, value: string) =>
                    {
                        if (value)
                        {
                            tooltipText += (tooltipText ? "<br>" : "") + `${label}: ${value}`
                        }
                    };

                    addLine(Txt.startTime, item.Start);
                    addLine(Txt.endTime, item.End);
                    if (item.LunchLength)
                    {
                        addLine(Txt.breakDuration, `${item.LunchLength} min`)
                    }
                    addLine(Txt.projects, item.ProjectNames);
                    addLine(Txt.workType, item.WorkTypeName);

                    Tooltip.attach(titleSpan, tooltipText, true);
                }
            }
        }
    }

    private addShortcut(item: TimesheetShortcut, parent): HTMLSpanElement
    {
        const span = Dom.createSpan("img-circle", "span-shortcut");
        span.style.backgroundColor = item.Color;
        span.textContent = item.Abbreviation;
        span.draggable = true;
        span.style.cursor = "grab";
        span.addEventListener("click", (e) =>
        {
            e.preventDefault();
            e.stopPropagation();
        });
        span.addEventListener("dragstart", (e: DragEvent) =>
        {
            if (e.dataTransfer)
            {
                e.dataTransfer.setData("text/plain", item.Abbreviation);
                e.dataTransfer.effectAllowed = "copy";
            }
        });

        const titleSpan = Dom.createSpan();
        titleSpan.textContent = ` ${item.Name}`;

        const button = Dom.createDiv("w-button-primary");
        button.style.marginRight = "5px";
        button.style.padding = "1px 10px 1px 2px";
        button.style.borderRadius = "50px";
        button.style.cursor = "auto";
        button.append(span, titleSpan);
        parent.append(button);

        return titleSpan;
    }
}
